<template>
  <v-container
    id="email"
    class="fill-height justify-center"
    tag="section"
    justify="center"
    align="center"
  >
  <v-img src="@/assets/powered-by-norven.svg" id="login-footer"/>
    <v-row align="center" justify="end" no-gutters>
      <v-col cols="12" sm="6" class="d-flex justify-center align-center">
        <img src="@/assets/animacao-logo-prisma.gif" width="1000" alt="Logotipo Prisma"/>
      </v-col>
      <v-col cols="12" sm="6">
        <login-wizard />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Login',
    components: {
      LoginWizard: () => import('@/components/login/LoginWizard'),
    }
  }
</script>

<style scoped>
#login-footer {
  margin:  0px 0px 16px 32px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 300px;
}
</style>
